import {
    IdCardWrapper,
    TitleAndCommandsWrapper,
    TitlesWrapper,
    IdCardTitle,
    ModuleTitle,
    ModuleTitleClickable,
    CommandsWrapper,
    PrintButton,
    ExitButton,
    EditButton,
    DetailsWrapper,
    TextualDetailsWrapper,
    VisualDetailsWrapper,
    SectionTitle,
    SubMenusWrapper,
    PhysicalWrapper,
    SecondarySystemWrapper,
    SectionTitleEl,
    SlotLoaderContainer,
    OriginalCharacteristics,
    OriginalCharacteristicsWrapper,
    CurrentLayoutActionContainer,
} from './styles';

import Description from '../../Description';
import Characteristics from '../../Characteristics';
import Physical from '../../Physical';
import ImageViewer from '../../ImageViewer';
import SubMenuItem from '../../SubMenuItem';
import ViewsAndLayouts from '../../ViewsAndLayouts';
import WeightBreakdown from '../../WeightBreakdown';
import LocationAndCraneCoverage from '../../LocationAndCraneCoverage';
import OtherRelevantDocuments from '../../OtherRelevantDocuments';
import ProjectNotes from '../../ProjectNotes';
import DocumentationList from '../../DocumentationList';
import EquipmentList from '../../EquipmentList';
import MainTieIns from '../../MainTieIns';
import Loader from '../../../components/Loader';
import NotFound from '../../../screens/NotFound';

import { user_roles } from '../../../config/enums';
import { useUser } from '../../../context/user';
import { useIdCard } from '../../../screens/HomeScreen/context/idCard';
import { useIdCatalogSearch } from '../../SideMenuSearchLane/context';
import { pick } from 'lodash';
import { useState } from 'react';
import EditIdCardModal from '../../EditIdCardModal';
import { AddToCurrentSectionButton, Right } from '../../IdCardCompareMode/styles';
import { PlusIcon } from '../../CatalogListItem/styles';
import { primaryColor } from '../../../config/colors';

const Module = ({ itemData, onAddToLayoutClick }) => {
    const { user } = useUser();
    const { idCard: idCardData, isLoading: isCardLoading } = itemData;
    const { removeCatalogItem, shouldRenderModuleItemAddIcon, addCatalogItem } = useIdCatalogSearch();
    const { setEditingCardTagId, setPrintMode } = useIdCard();
    const [isEditModalOpened, setIsEditModalOpened] = useState(false);

    const shouldRenderNotFound = !Boolean(idCardData) && !isCardLoading;
    const shouldRenderLoader = isCardLoading;

    const onEditCard = () => {
        setEditingCardTagId(idCardData.tagId);
        setIsEditModalOpened(true);
    };

    return <IdCardWrapper>
            {shouldRenderNotFound ? (
                <NotFound />
            ) : shouldRenderLoader ? (
                <SlotLoaderContainer>
                    <Loader />
                </SlotLoaderContainer>
            ) : (
                <>
                    <CommandsWrapper>
                        <PrintButton
                            title='Print Card'
                            onClick={() => setPrintMode(true)}
                        />

                        {(user.roles.includes(user_roles.admin) || user?.roles.includes(user_roles.catalogAdmin) || user?.roles.includes(user_roles.castAdmin)) && (
                            <EditButton
                                title='Edit Card'
                                onClick={() => onEditCard()}
                            />
                        )}
                        <ExitButton onClick={() => removeCatalogItem(idCardData.tagId)} />
                    </CommandsWrapper>
                    <TitleAndCommandsWrapper>
                        <TitlesWrapper>
                            <ModuleTitleClickable onClick={() => addCatalogItem(idCardData.projectId, true)}>
                                <SectionTitleEl>Project: </SectionTitleEl>
                                <SectionTitleEl>{`${idCardData.project ? idCardData.project : ''}`}</SectionTitleEl>
                            </ModuleTitleClickable>
                            <IdCardTitle>
                                <SectionTitleEl>Module: </SectionTitleEl>
                                <SectionTitleEl>{`${idCardData.tsCode ?? ''} - ${idCardData.name}`}</SectionTitleEl>
                            </IdCardTitle>
                            <ModuleTitle>
                                <SectionTitleEl>Family: </SectionTitleEl>
                                <SectionTitleEl>{`${idCardData.family ? idCardData.family : ''}`}</SectionTitleEl>
                            </ModuleTitle>
                            <ModuleTitle>
                                <SectionTitleEl>Secondary system: </SectionTitleEl>
                                <SectionTitleEl>{`${idCardData.secondarySystem ? idCardData.secondarySystem : ''}`}</SectionTitleEl>
                            </ModuleTitle>
                            <ModuleTitle>
                                <SectionTitleEl>Design maturity: </SectionTitleEl>
                                <SectionTitleEl>{`${idCardData.designMaturity}`}</SectionTitleEl>
                            </ModuleTitle>
                        </TitlesWrapper>
                    </TitleAndCommandsWrapper>

                    {shouldRenderModuleItemAddIcon && (
                        <CurrentLayoutActionContainer>
                            <AddToCurrentSectionButton onClick={() => onAddToLayoutClick(idCardData)}>
                                <PlusIcon
                                    backgroundColor={primaryColor}
                                    title='Add module'>
                                    +
                                </PlusIcon>
                                <label className='add-to-layout'>Add to current layout</label>
                            </AddToCurrentSectionButton>
                        </CurrentLayoutActionContainer>
                    )}

                    <DetailsWrapper>
                        <TextualDetailsWrapper>
                            <SectionTitle>Description:</SectionTitle>
                            <Description description={idCardData.description} />

                            <SectionTitle>
                                {idCardData.characteristicsLabel && idCardData.characteristicsLabel.length > 0
                                    ? idCardData.characteristicsLabel
                                    : 'Characteristics:'}
                            </SectionTitle>
                            <Characteristics characteristics={idCardData.characteristics} />
                            <OriginalCharacteristicsWrapper>
                                <div>Original characteristics:</div>
                                <OriginalCharacteristics>{idCardData.originalCharacteristics}</OriginalCharacteristics>
                            </OriginalCharacteristicsWrapper>

                            <SectionTitle>Secondary system:</SectionTitle>
                            <SecondarySystemWrapper>{idCardData.secondarySystem}</SecondarySystemWrapper>

                            <PhysicalWrapper>
                                <SectionTitle>Physical:</SectionTitle>
                                <Physical {...pick(idCardData, ['totalWeightDry', 'length', 'height', 'width'])} />
                            </PhysicalWrapper>
                        </TextualDetailsWrapper>

                        <VisualDetailsWrapper>
                            <ImageViewer
                                imageId={idCardData.images && idCardData.images.length > 0 ? idCardData.images[0].imageId : ''}
                                fullscreen={false}
                                defaultLoaderSize={75}
                                containerStyle={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            />
                        </VisualDetailsWrapper>
                    </DetailsWrapper>
                    <SubMenusWrapper>
                        <SubMenuItem
                            title={'Views And Layouts'}
                            component={<ViewsAndLayouts images={idCardData.images} />}
                        />
                        <SubMenuItem
                            title={'Weight Breakdown'}
                            component={<WeightBreakdown idCardData={idCardData} />}
                        />
                        <SubMenuItem
                            title={'Location on FPSO'}
                            component={<LocationAndCraneCoverage images={idCardData.images} />}
                        />
                        <SubMenuItem
                            title={'Main Tie-Ins & Interfaces'}
                            component={
                                <MainTieIns
                                    {...pick(idCardData, ['tieIns', 'tieInsComment', 'tieInsOtherUtilities', 'tieInsOtherNetworks'])}
                                />
                            }
                        />
                        <SubMenuItem
                            title={'Key Equipment List'}
                            component={<EquipmentList {...pick(idCardData, ['equipmentList', 'equipmentListComment'])} />}
                        />
                        <SubMenuItem
                            title={'Documentation List'}
                            component={<DocumentationList documents={idCardData.documents} />}
                        />
                        <SubMenuItem
                            title={'Other Relevant Documents'}
                            component={<OtherRelevantDocuments otherDocuments={idCardData.otherDocuments} />}
                        />
                        <SubMenuItem
                            title={'Project Notes'}
                            component={<ProjectNotes resNotes={idCardData.resNotes} />}
                        />
                    </SubMenusWrapper>
                </>
            )}
            {isEditModalOpened && (
                <EditIdCardModal
                    isEditMode={true}
                    onModalClose={() => setIsEditModalOpened(false)}
                />
            )}
        </IdCardWrapper>
};

export default Module;
